import { toast } from 'react-toastify';

/**
 * @param {Any} error
 * @param {boolean} withErrorToast
 * @returns {Promise}
 */

export const handleFetchError = async (error, withErrorToast) => {
    const { res } = error;
    const genericError = new Error('Fetch error');
    genericError.res = res;
    genericError.data = { success: false, message: 'An error occured.' };
    genericError.originalError = error;

    if (error.name === 'AbortError') {
        // we do not show any error to user, becuase we expect that new
        // request was started after current was cancelled
        throw genericError;
    }

    try {
        if (
            typeof res !== 'undefined' &&
            typeof res.data === 'object' &&
            res.data.message
        ) {
            genericError.data = res.data;
        }
    } catch (caughtError) {
        // eslint-disable-next-line no-console
        console.error(caughtError);
    }

    if (
        withErrorToast &&
        genericError &&
        genericError.data &&
        genericError.data.message
    ) {
        toast.error(genericError.data.message);
    }

    throw genericError;
};

const getConfig = config => {
    return {
        ...config,
        headers: { ...config.headers }
    };
};

/**
 * @param {Object} settings
 * @param {Object} headers
 * @param {Object} options
 * @returns {Promise}
 */
function fetchJSON(
    settings,
    headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    options = { withErrorToast: true }
) {
    const config = {
        method: settings.method,
        body: settings.body || null,
        credentials: 'same-origin'
    };
    const { withErrorToast } = options;

    // when binary is in body, you cannot set headers, browser will
    // handle it by itself
    if (headers) {
        config.headers = headers;
    }

    // used for cancellable fetch
    if (settings.signal) {
        config.signal = settings.signal;
    }

    return fetch(settings.url, getConfig(config))
        .then(response => response.json())
        .then(response => {
            if (response && response.success) {
                return response;
            }

            // eslint-disable-next-line no-throw-literal
            throw {
                res: {
                    data: {
                        message: response.message,
                        modelErrors: response.modelErrors,
                        payload: response.payload,
                        success: response.success
                    }
                }
            };
        })
        .catch(error => handleFetchError(error, withErrorToast));
}

export default fetchJSON;
